/**
 * Created by ricardocabret on 10/13/16.
 */

Array.prototype.chunkArray = function (chunkSize) {
    let groups = [], i;
    for (i = 0; i < this.length; i += chunkSize) {
        groups.push(this.slice(i, i + chunkSize));
    }
    return groups;
};

Array.prototype.flattenArray = function () {
    let groups = [], i;
    for (i = 0; i < this.length; i++) {
        groups = groups.concat(this[i]);
    }
    return groups;
};


Array.prototype.includes = function (val) {
    for (let i = 0; i < this.length; i++) {
        if (this[i] === val) {
            return true;
        }
    }
    return false;
};

Array.prototype.remove = function (val) {
    for (let i = 0; i < this.length; i++) {
        if (this[i] === val) {
            this.splice(i, 1);
        }
    }
};

String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};